import PropTypes from "prop-types";
// Components
import SimpleIconButton from "@Layouts/components/Buttons/SimpleIconButton";

// Icons
import { ReactComponent as ChargeBackIcon } from "@/assets/icons/common/chargeback.svg";

function Chargebacks(props) {
	const { apiRef, color, disabled, onChargeBackAction } = props;

	const onClickHandler = () => {
		const selectedIds = apiRef.current.getSelectedRows();
		onChargeBackAction?.([...selectedIds.values()].map((item) => item.id || item._id));
	};
	return (
		<SimpleIconButton
			onClick={onClickHandler}
			icon={<ChargeBackIcon color={color} width={18} />}
			disabled={disabled}
			className={color}
		/>
	);
}

Chargebacks.propTypes = {
	apiRef: PropTypes.shape({
		current: PropTypes.object,
	}),
	color: PropTypes.string,
	disabled: PropTypes.bool,
	onChargeBackAction: PropTypes.func,
};

export default Chargebacks;
